import { useContext } from 'react';

import { HoneycombBaseScaleContext } from '../context/honeycomb-base-scale.context.js';

export const useHoneycombBaseScale = () =>
  useContext(HoneycombBaseScaleContext);
